"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRouter = generateRouter;
const debug_1 = __importDefault(require("debug"));
const render_router_1 = require("./internal/render-router");
function generateRouter({ contractName = 'Router', template = undefined, canReceivePlainETH = false, hasDiamondCompat = false, contracts, }) {
    for (const c of contracts)
        (0, debug_1.default)(`${c.contractName}: ${c.deployedAddress}`);
    const sourceCode = (0, render_router_1.renderRouter)({
        routerName: contractName,
        template,
        canReceivePlainETH,
        hasDiamondCompat,
        contracts,
    });
    return sourceCode;
}
//# sourceMappingURL=generate.js.map